import "vite-dep-pre-bundle-external:/home/cmiss/Jenkins/workspace/mapintegratedvuer/node_modules/maplibre-gl/dist/maplibre-gl.css";